import SubscriptionPromo from "../Layout/Items/SubscriptionPromo";
import { handleStripePortalRedirect } from "../../services/api";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

export const AccountSection = () => {
  const { subscription } = useAuth();
  const navigate = useNavigate();

  const handlePricingClick = () => {
    navigate('/pricing');
  };

  const formatDate = (timestamp: number) => {
    return new Date(timestamp * 1000).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'active': return '#10b981';
      case 'trialing': return 'var(--primary-color)';
      case 'past_due': return '#f59e0b';
      case 'canceled': return '#ef4444';
      case 'paused': return '#6b7280';
      case 'expired': return '#ef4444';
      default: return '#6b7280';
    }
  };

  const getStatusText = (status: string) => {
    switch (status) {
      case 'active': return 'Active';
      case 'trialing': return 'Trial';
      case 'past_due': return 'Past Due';
      case 'canceled': return 'Canceled';
      case 'paused': return 'Paused';
      case 'expired': return 'Expired';
      default: return status;
    }
  };

  return (
    <div>
      {!subscription ? (
        <SubscriptionPromo />
      ) : (
        <>
          <div className="settings-item">
            <h3>Subscription Details</h3>
            
            <div className="subscription-overview">
              <div className="subscription-header">
                <div className="plan-info">
                  <h4>{subscription.plan?.toUpperCase() || 'N/A'} Plan</h4>
                </div>
                <div className="billing-info">
                  <span className="billing-interval">
                    Billed {subscription.interval === 'annual' ? 'Annually' : 'Monthly'}
                  </span>
                </div>
              </div>

              <div className="subscription-details-grid">
                <div className="detail-item">
                  <label>Status</label>
                  <span style={{ color: getStatusColor(subscription.status) }}>
                    {getStatusText(subscription.status)}
                  </span>
                </div>

                <div className="detail-item">
                  <label>Current Period Ends</label>
                  <span>{formatDate(subscription.currentPeriodEnd)}</span>
                </div>

                {subscription.trialEnd && (
                  <div className="detail-item">
                    <label>Trial Ends</label>
                    <span>{formatDate(subscription.trialEnd)}</span>
                  </div>
                )}
              </div>
            </div>

            <div className="subscription-actions">
              <button 
                onClick={() => handleStripePortalRedirect(window.location.href)} 
                className="button-main"
              >
                Manage Subscription
              </button>
              <button 
                onClick={handlePricingClick} 
                className="subscription-details-link"
              >
                Compare Plans and Features
              </button>
            </div>

            {subscription?.status === 'trialing' && (
              <div className="trial-disclaimer">
                <p className='trial-disclaimer-text'>
                  Cancellation of the trial will result in the immediate termination of your subscription.
                </p>
              </div>
            )}

            {subscription?.status === 'past_due' && (
              <div className="past-due-warning">
                <p className='warning-text'>
                  Your subscription payment is past due. Please update your payment method to continue using premium features.
                </p>
              </div>
            )}

            {(subscription?.status === 'canceled' || subscription?.status === 'expired') && (
              <div className="canceled-notice">
                <p className='notice-text'>
                  Your subscription has been {subscription.status}. You can reactivate it or choose a new plan.
                </p>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}; 